import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatSnackBarModule, MatButtonModule, MatInputModule, MatIconModule } from '@angular/material';
import { CoachResetPasswordComponent } from './coach-reset-password.component';

@NgModule({
  declarations: [CoachResetPasswordComponent],
  imports: [
    CommonModule,
    FormsModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    MatSnackBarModule,
    ReactiveFormsModule
  ]
})
export class CoachResetPasswordModule { }
